/** Inline status indicator with colour variants. */
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/foundation/utils/cn';

export const badgeVariants = cva('inline-flex items-center rounded-[12px] font-semibold', {
  variants: {
    variant: {
      default: 'bg-[var(--f-bg-sunken)] text-[var(--f-fg-secondary)]',
      success: 'bg-[var(--f-success-subtle)] text-[var(--f-success-text)]',
      danger: 'bg-[var(--f-error-subtle)] text-[var(--f-error-text)]',
      info: 'bg-[var(--f-info-subtle)] text-[var(--f-info-text)]',
      warning: 'bg-[var(--f-warning-subtle)] text-[var(--f-warning-text)]',
      muted: 'bg-[var(--f-bg-sunken)] text-[var(--f-fg-muted)]',
    },
    size: {
      sm: 'px-2 py-0.5 text-xs',
      md: 'px-3 py-1 text-xs',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'md',
  },
});

export type BadgeVariants = VariantProps<typeof badgeVariants>;

interface BadgeProps extends BadgeVariants {
  children: React.ReactNode;
  className?: string;
}

export function Badge({ variant, size, className, children }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant, size }), className)}>{children}</span>;
}
